export const BASE_URL="https://lmiaapi.netwaveisp.com/api"